
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34394',
  depVersions: {
  "documents-public-ui": "static-1.34394",
  "client-types": "static-1.461",
  "documents-lib": "static-1.34399",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2088",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5549",
  "hs-test-utils": "static-1.7972",
  "hub-http": "static-1.6177",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11417",
  "I18n": "static-7.1611",
  "jasmine-immutable": "static-1.2974",
  "jasmine-runner": "static-1.6425",
  "lodash": "static-1.3",
  "quartz": "static-1.6962",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16623",
  "reporting-data": "static-1.67317",
  "reporting-testing-lib": "static-1.9250",
  "reporting-visualizations": "static-1.59393",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4725",
  "webpack-env": "static-1.54",
  "atom": "static-1.5028",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2454",
  "classnames": "static-2.10",
  "cssUtils": "static-1.779",
  "customer-data-filters-ui": "static-1.39580",
  "customer-data-objects": "static-1.7618",
  "customer-data-property-utils": "static-1.8039",
  "data-fetching-client": "static-1.9630",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4477",
  "flux-actions": "static-1.331",
  "FormsCommonComponents": "static-1.85700",
  "FormUrlGenerator": "static-2.4675",
  "foundations-components": "static-1.7843",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11725",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7114",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3802",
  "property-translator": "static-1.5357",
  "quartz-config": "static-1.740",
  "quartz-core": "static-1.6181",
  "quick-fetch": "static-1.3880",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5307",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8126",
  "reference-resolvers-lite": "static-1.8050",
  "report-customization-components": "static-1.13028",
  "reporting-enablement": "static-1.22736",
  "reporting-reports": "static-1.66995",
  "reporting-snowflake": "static-1.55935",
  "reporting-ui-components": "static-2.64588",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4606",
  "sales-content-partitioning": "static-1.8893",
  "SalesContentIndexUI": "static-3.9174",
  "sanitize": "static-1.4428",
  "sanitize-text": "static-1.8099",
  "self-service-api": "static-1.10201",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1702",
  "signup-constants": "static-1.18755",
  "signup-ui-lego-core": "static-1.20765",
  "signup-ui-url-generator": "static-2.7996",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4722",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10944",
  "ui-addon-i18n": "static-1.11106",
  "ui-addon-react-router-dom": "static-1.9501",
  "ui-addon-upgrades": "static-9.17921",
  "ui-asset-management-lib": "static-1.10965",
  "ui-images": "static-2.1140",
  "UIComponents": "static-3.8364",
  "usage-tracker": "static-1.7294",
  "usage-tracker-container": "static-1.7284",
  "usage-tracker-core": "static-1.7144",
  "usage-tracker-public": "static-1.7105",
  "viral-links-lib": "static-1.7010",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3367",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3239",
  "quartz-webpack": "static-1.3186",
  "ai-components-ui-library": "static-1.8811",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4812",
  "foundations-theming": "static-1.4372",
  "quartz-auth": "static-1.637",
  "ui-business-units-lib": "static-1.9004",
  "usage-tracker-session-replay": "static-1.4980",
  "foundations-theming-base": "static-1.3357",
  "HeadJS": "static-2.741",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3083",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.47",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4280",
  "csstype": "static-1.50",
  "quartz-head": "static-1.627",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7883",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3554",
  "persist-promise": "static-1.3663",
  "quartz-i18n": "static-1.637",
  "reporting-client-types": "static-1.2470",
  "foundations-components-legacy": "static-1.868",
  "hs-story-utils": "static-1.9384",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9853",
  "hubspotter-http": "static-1.4615",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7204",
  "crm-message-bus": "static-1.42854",
  "customer-data-filters-ui-msw-helpers": "static-1.22015",
  "customer-data-objects-ui-components": "static-1.12981",
  "customer-data-reference-ui-components": "static-1.13115",
  "customer-data-ui-utilities": "static-1.9782",
  "framework-builder-read-service-client": "static-1.3973",
  "framework-data-schema-quick-fetch": "static-1.6739",
  "framework-data-schema-resolvers": "static-1.6834",
  "inbound-db-properties-service-client": "static-1.3804",
  "multi-account-reference-resolvers": "static-1.935",
  "onboarding-tours": "static-1.16507",
  "reporting-datasets-permissions-lib": "static-1.13530",
  "ui-addon-teams": "static-1.21487",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68220",
  "customer-data-properties": "static-1.51374",
  "forms-ai-lib": "static-1.4242",
  "forms-utils-lib": "static-1.12491",
  "foundations-components-test-utils": "static-1.5326",
  "react-dnd-compat": "static-1.4576",
  "react-tinymce": "static-1.55102",
  "tinymce-config": "static-2.54228",
  "ui-gdpr-components": "static-1.10303",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4112",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.10",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1700",
  "ui-fonts": "static-1.679",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.827",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.392",
  "quartz-test": "static-1.637",
  "quartz-tracking": "static-1.341",
  "batch-promise": "static-1.1506",
  "external-options-client-types": "static-1.4122",
  "react-colorpicker": "static-2.10166",
  "copilot-toolkit": "static-1.10990",
  "data-quality-ui-library": "static-1.12781",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6418",
  "reporting-action-components": "static-1.41169",
  "reporting-filters": "static-1.192",
  "reporting-insights-lib": "static-1.1586",
  "reporting-plugins": "static-1.10212",
  "ui-addon-draggable-compat": "static-2.4210",
  "ui-addon-opt": "static-4.8329",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25223",
  "hubspot-apollo-client": "static-1.4832",
  "bend-plugin-chirp-manifest": "static-1.16",
  "chirp-fetch": "static-1.1841",
  "sales-templates-service-types-lib": "static-1.4131",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5799",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4041",
  "nested-table": "static-1.181",
  "timezone-utils": "static-2.5200",
  "bender-build-tools": "static-1.3123",
  "chatspot-core": "static-1.21054",
  "bend-plugin-foundations-theming": "static-1.2855",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9851",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3760",
  "crm-pipelines-api-client-types": "static-1.4106",
  "multi-currency-client-types": "static-1.3655",
  "getting-started-shared-tasks": "static-1.18358",
  "growth-data-modal": "static-1.5352",
  "growth-onboarding-confetti": "static-1.3023",
  "growth-onboarding-next-action-utils": "static-1.1770",
  "navigation-components": "static-1.17870",
  "onboarding-tours-client": "static-1.4721",
  "onboarding-tours-utils": "static-1.573",
  "ui-shepherd-react": "static-3.10104",
  "ui-shepherd-tracker": "static-1.7485",
  "ui-universal-auth": "static-1.8919",
  "user-context": "static-1.5057",
  "cms-field-types": "static-1.4767",
  "content-icons-ui": "static-1.2213",
  "integrations-lib": "static-1.15961",
  "calling-global-api": "static-1.64341",
  "calling-internal-common": "static-1.31257",
  "calling-lifecycle-internal": "static-1.65723",
  "calling-lifecycle-messages": "static-1.58017",
  "commerce-products-lib": "static-1.9346",
  "crm-links": "static-1.6238",
  "customer-data-properties-shared-msw-handlers": "static-1.9180",
  "file-manager-components": "static-1.23485",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.102",
  "inbounddb-objects-service-types": "static-1.4187",
  "meetings-icalendar-utils-lib": "static-1.587",
  "object-builder-ui-client": "static-1.48569",
  "pipeline-validation-client-types": "static-1.3929",
  "property-value-citations": "static-1.1988",
  "pulse": "static-1.513",
  "smart-property-lib": "static-1.6687",
  "tiered-pricing": "static-1.1112",
  "ui-addon-iframeable": "static-1.9011",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19749",
  "tinymce-themes": "static-1.56198",
  "data-token-picker": "static-1.16322",
  "hub-http-contrib": "static-1.2996",
  "interframe": "static-3.4717",
  "tinymce-data": "static-1.40313",
  "tinymce-plugins": "static-1.57342",
  "ui-addon-sales-email": "static-1.5166",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5531",
  "magpie-types": "static-1.4991",
  "simple-logging-lib": "static-1.3005",
  "content-assistance-lib": "static-1.7679",
  "dashboard-lib": "static-1.81328",
  "ExportDialog": "static-6.10349",
  "hubspot-prosemirror": "static-1.18096",
  "hubspot-prosemirror-plugins": "static-1.18088",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8653",
  "campaign-roi-lib": "static-1.8931",
  "feedback-loader": "static-1.29212",
  "apollo-link-hub-http": "static-2.4604",
  "hubspot-apollo-cache": "static-1.291",
  "purchase-motions-api": "static-1.5802",
  "trials-service-types": "static-1.3859",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.129",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1882",
  "growth-onboarding-next-action-components": "static-1.1798",
  "user-context-client": "static-1.4566",
  "idb-keyval": "static-1.43",
  "nest": "static-1.183",
  "reactive-lib": "static-1.677",
  "unified-auth-core-lib": "static-1.714",
  "getting-started-shared-tasks-store": "static-1.17476",
  "integrations-error-boundary-lib": "static-1.13376",
  "integrations-tracking-lib": "static-1.5554",
  "native-integrations-shared-strings": "static-1.7739",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10327",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.433",
  "calling-error-reporting": "static-1.31263",
  "shared-worker-versioning": "static-1.10993",
  "calling-usage-tracker": "static-1.6498",
  "voice-sms-access-library": "static-1.788",
  "customer-data-tracking": "static-1.6841",
  "commerce-permissions": "static-1.721",
  "products-iframe-lib": "static-1.7786",
  "products-ui-components-shared-msw-handlers": "static-1.10235",
  "location-customization-utils-lib": "static-1.9099",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4109",
  "video-components-external": "static-1.11108",
  "video-data-lib": "static-1.34766",
  "bend-plugin-pulse": "static-1.16",
  "directed-graph": "static-1.891",
  "event-emitter": "static-1.904",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.118",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9936",
  "fsm": "static-1.3688",
  "policy-lib": "static-1.6728",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9999",
  "navigation-messaging": "static-1.7197",
  "FileManagerLib": "static-1.39125",
  "NamespacedHubStyle": "static-2.9026",
  "FileManagerCore": "static-1.38984",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12352",
  "layout-dnd-utils": "static-1.11327",
  "react-codemirror": "static-1.10579",
  "ui-addon-emoji-picker": "static-1.9844",
  "ui-brand-identity-lib": "static-1.15032",
  "ui-addon-video-player": "static-1.8654",
  "ui-coaching-tips": "static-1.28408",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23395",
  "EmailSignatureEditor": "static-1.24270",
  "InboxConnectUtils": "static-4.14665",
  "universal-page-editor-lib": "static-1.2968",
  "google-sheets-integration-lib": "static-1.93",
  "microsoft-drive-integration-lib": "static-1.206",
  "calling-orchestration-schema": "static-1.35565",
  "sales-views-client-types": "static-1.4220",
  "crm-record-cards-service-types": "static-1.3572",
  "content-media-composition-data-lib": "static-1.12087",
  "content-media-compositions": "static-2.16094",
  "media-bridge-lib": "static-1.18845",
  "trellis-story-utils": "static-1.4471",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5844",
  "FileManagerImages": "static-1.36636",
  "video-components": "static-1.13111",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4487",
  "video-embed": "static-1.35600",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68295",
  "layout-data-lib": "static-1.9652",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6539",
  "commerce-tours-lib": "static-1.6007",
  "growth-onboarding-reliability": "static-1.5037",
  "sales-checkout-service-client": "static-1.3595",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21588",
  "sales-email-signature-service-client": "static-1.3799",
  "social-insights-client-types": "static-1.21952",
  "outpost": "static-1.4144",
  "advanced-menus-core": "static-1.15053",
  "advanced-menus-lib": "static-1.12004",
  "ui-memberships-settings-lib": "static-1.33912",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15052",
  "simple-menus-lib": "static-1.16569"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34394",
  "client-types": "/client-types/static-1.461",
  "documents-lib": "/documents-lib/static-1.34399",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2088",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5549",
  "hs-test-utils": "/hs-test-utils/static-1.7972",
  "hub-http": "/hub-http/static-1.6177",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11417",
  "I18n": "/I18n/static-7.1611",
  "jasmine-immutable": "/jasmine-immutable/static-1.2974",
  "jasmine-runner": "/jasmine-runner/static-1.6425",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6962",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16623",
  "reporting-data": "/reporting-data/static-1.67317",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9250",
  "reporting-visualizations": "/reporting-visualizations/static-1.59393",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4725",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5028",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2454",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.779",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39580",
  "customer-data-objects": "/customer-data-objects/static-1.7618",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8039",
  "data-fetching-client": "/data-fetching-client/static-1.9630",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4477",
  "flux-actions": "/flux-actions/static-1.331",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85700",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4675",
  "foundations-components": "/foundations-components/static-1.7843",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11725",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7114",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3802",
  "property-translator": "/property-translator/static-1.5357",
  "quartz-config": "/quartz-config/static-1.740",
  "quartz-core": "/quartz-core/static-1.6181",
  "quick-fetch": "/quick-fetch/static-1.3880",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5307",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8126",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8050",
  "report-customization-components": "/report-customization-components/static-1.13028",
  "reporting-enablement": "/reporting-enablement/static-1.22736",
  "reporting-reports": "/reporting-reports/static-1.66995",
  "reporting-snowflake": "/reporting-snowflake/static-1.55935",
  "reporting-ui-components": "/reporting-ui-components/static-2.64588",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4606",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8893",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9174",
  "sanitize": "/sanitize/static-1.4428",
  "sanitize-text": "/sanitize-text/static-1.8099",
  "self-service-api": "/self-service-api/static-1.10201",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1702",
  "signup-constants": "/signup-constants/static-1.18755",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20765",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7996",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4722",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10944",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11106",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9501",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17921",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10965",
  "ui-images": "/ui-images/static-2.1140",
  "UIComponents": "/UIComponents/static-3.8364",
  "usage-tracker": "/usage-tracker/static-1.7294",
  "usage-tracker-container": "/usage-tracker-container/static-1.7284",
  "usage-tracker-core": "/usage-tracker-core/static-1.7144",
  "usage-tracker-public": "/usage-tracker-public/static-1.7105",
  "viral-links-lib": "/viral-links-lib/static-1.7010",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3367",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3239",
  "quartz-webpack": "/quartz-webpack/static-1.3186",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8811",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4812",
  "foundations-theming": "/foundations-theming/static-1.4372",
  "quartz-auth": "/quartz-auth/static-1.637",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9004",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4980",
  "foundations-theming-base": "/foundations-theming-base/static-1.3357",
  "HeadJS": "/HeadJS/static-2.741",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3083",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.47",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4280",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.627",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7883",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3554",
  "persist-promise": "/persist-promise/static-1.3663",
  "quartz-i18n": "/quartz-i18n/static-1.637",
  "reporting-client-types": "/reporting-client-types/static-1.2470",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.868",
  "hs-story-utils": "/hs-story-utils/static-1.9384",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9853",
  "hubspotter-http": "/hubspotter-http/static-1.4615",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7204",
  "crm-message-bus": "/crm-message-bus/static-1.42854",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22015",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12981",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13115",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9782",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3973",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6739",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6834",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3804",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.935",
  "onboarding-tours": "/onboarding-tours/static-1.16507",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13530",
  "ui-addon-teams": "/ui-addon-teams/static-1.21487",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68220",
  "customer-data-properties": "/customer-data-properties/static-1.51374",
  "forms-ai-lib": "/forms-ai-lib/static-1.4242",
  "forms-utils-lib": "/forms-utils-lib/static-1.12491",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5326",
  "react-dnd-compat": "/react-dnd-compat/static-1.4576",
  "react-tinymce": "/react-tinymce/static-1.55102",
  "tinymce-config": "/tinymce-config/static-2.54228",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10303",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4112",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.10",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1700",
  "ui-fonts": "/ui-fonts/static-1.679",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.392",
  "quartz-test": "/quartz-test/static-1.637",
  "quartz-tracking": "/quartz-tracking/static-1.341",
  "batch-promise": "/batch-promise/static-1.1506",
  "external-options-client-types": "/external-options-client-types/static-1.4122",
  "react-colorpicker": "/react-colorpicker/static-2.10166",
  "copilot-toolkit": "/copilot-toolkit/static-1.10990",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12781",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6418",
  "reporting-action-components": "/reporting-action-components/static-1.41169",
  "reporting-filters": "/reporting-filters/static-1.192",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1586",
  "reporting-plugins": "/reporting-plugins/static-1.10212",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4210",
  "ui-addon-opt": "/ui-addon-opt/static-4.8329",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25223",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4832",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.16",
  "chirp-fetch": "/chirp-fetch/static-1.1841",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4131",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5799",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4041",
  "nested-table": "/nested-table/static-1.181",
  "timezone-utils": "/timezone-utils/static-2.5200",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "chatspot-core": "/chatspot-core/static-1.21054",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2855",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9851",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3760",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4106",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3655",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18358",
  "growth-data-modal": "/growth-data-modal/static-1.5352",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3023",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1770",
  "navigation-components": "/navigation-components/static-1.17870",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4721",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.573",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10104",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7485",
  "ui-universal-auth": "/ui-universal-auth/static-1.8919",
  "user-context": "/user-context/static-1.5057",
  "cms-field-types": "/cms-field-types/static-1.4767",
  "content-icons-ui": "/content-icons-ui/static-1.2213",
  "integrations-lib": "/integrations-lib/static-1.15961",
  "calling-global-api": "/calling-global-api/static-1.64341",
  "calling-internal-common": "/calling-internal-common/static-1.31257",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65723",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58017",
  "commerce-products-lib": "/commerce-products-lib/static-1.9346",
  "crm-links": "/crm-links/static-1.6238",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9180",
  "file-manager-components": "/file-manager-components/static-1.23485",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.102",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4187",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.587",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48569",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3929",
  "property-value-citations": "/property-value-citations/static-1.1988",
  "pulse": "/pulse/static-1.513",
  "smart-property-lib": "/smart-property-lib/static-1.6687",
  "tiered-pricing": "/tiered-pricing/static-1.1112",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9011",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19749",
  "tinymce-themes": "/tinymce-themes/static-1.56198",
  "data-token-picker": "/data-token-picker/static-1.16322",
  "hub-http-contrib": "/hub-http-contrib/static-1.2996",
  "interframe": "/interframe/static-3.4717",
  "tinymce-data": "/tinymce-data/static-1.40313",
  "tinymce-plugins": "/tinymce-plugins/static-1.57342",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5166",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5531",
  "magpie-types": "/magpie-types/static-1.4991",
  "simple-logging-lib": "/simple-logging-lib/static-1.3005",
  "content-assistance-lib": "/content-assistance-lib/static-1.7679",
  "dashboard-lib": "/dashboard-lib/static-1.81328",
  "ExportDialog": "/ExportDialog/static-6.10349",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18096",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18088",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8653",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8931",
  "feedback-loader": "/feedback-loader/static-1.29212",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4604",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.291",
  "purchase-motions-api": "/purchase-motions-api/static-1.5802",
  "trials-service-types": "/trials-service-types/static-1.3859",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.129",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1882",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1798",
  "user-context-client": "/user-context-client/static-1.4566",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.183",
  "reactive-lib": "/reactive-lib/static-1.677",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.714",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17476",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13376",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5554",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7739",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10327",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.433",
  "calling-error-reporting": "/calling-error-reporting/static-1.31263",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10993",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6498",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.788",
  "customer-data-tracking": "/customer-data-tracking/static-1.6841",
  "commerce-permissions": "/commerce-permissions/static-1.721",
  "products-iframe-lib": "/products-iframe-lib/static-1.7786",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10235",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9099",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4109",
  "video-components-external": "/video-components-external/static-1.11108",
  "video-data-lib": "/video-data-lib/static-1.34766",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.16",
  "directed-graph": "/directed-graph/static-1.891",
  "event-emitter": "/event-emitter/static-1.904",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.118",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9936",
  "fsm": "/fsm/static-1.3688",
  "policy-lib": "/policy-lib/static-1.6728",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9999",
  "navigation-messaging": "/navigation-messaging/static-1.7197",
  "FileManagerLib": "/FileManagerLib/static-1.39125",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9026",
  "FileManagerCore": "/FileManagerCore/static-1.38984",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12352",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11327",
  "react-codemirror": "/react-codemirror/static-1.10579",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9844",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15032",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8654",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28408",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23395",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24270",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14665",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2968",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.93",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.206",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35565",
  "sales-views-client-types": "/sales-views-client-types/static-1.4220",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3572",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12087",
  "content-media-compositions": "/content-media-compositions/static-2.16094",
  "media-bridge-lib": "/media-bridge-lib/static-1.18845",
  "trellis-story-utils": "/trellis-story-utils/static-1.4471",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5844",
  "FileManagerImages": "/FileManagerImages/static-1.36636",
  "video-components": "/video-components/static-1.13111",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4487",
  "video-embed": "/video-embed/static-1.35600",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68295",
  "layout-data-lib": "/layout-data-lib/static-1.9652",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6539",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6007",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5037",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3595",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21588",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3799",
  "social-insights-client-types": "/social-insights-client-types/static-1.21952",
  "outpost": "/outpost/static-1.4144",
  "advanced-menus-core": "/advanced-menus-core/static-1.15053",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12004",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33912",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15052",
  "simple-menus-lib": "/simple-menus-lib/static-1.16569"
}
};
